import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appScrollContentItem]',
})
export class ScrollContentItemDirective {
  get rect(): ClientRect | DOMRect {
    return this.elementRef.nativeElement.getBoundingClientRect();
  }

  constructor(readonly elementRef: ElementRef) {}
}
